import { createBrowserRouter, RouterProvider, Navigate } from "react-router-dom";

import CostCreditReport from "./components/routes/reports/costCreditReport";
import AppSettingList from "./components/routes/management/appSettingList";
import ContainerList from "./components/routes/management/containerList";
import ContainerAdd from "./components/routes/management/containerAdd";
import ContainerEdit from "./components/routes/management/containerEdit";
import CustomerAdd from "./components/routes/management/customerAdd";
import CustomerClosing from "./components/routes/management/customerClosing";
import CustomerEdit from "./components/routes/management/customerEdit";
import CustomerList from "./components/routes/management/customerList";
import DocumentAdd from "./components/routes/management/documentAdd";
import DocumentView from "./components/routes/management/documentView";
import DocumentList from "./components/routes/management/documentList";
import EmployeeAdd from "./components/routes/management/employeeAdd";
import EmployeeEdit from "./components/routes/management/employeeEdit";
import EmployeeList from "./components/routes/management/employeeList";
import Error from "./components/routes/error";
import ExpenseAdd from "./components/routes/management/expenseAdd";
import ExpenseEdit from "./components/routes/management/expenseEdit";
import ExpenseList from "./components/routes/management/expenseList";
import Home from "./components/routes/home";
import LoadList from "./components/routes/tils/loadList";
import LoadAdd from "./components/routes/tils/loadAdd";
import LoadEdit from "./components/routes/tils/loadEdit";
import DeletedLoadList from "./components/routes/tils/deletedLoadList";
import LoadWeightsReport from "./components/routes/reports/inactive/loadWeightsReport";
import MaterialList from "./components/routes/management/materialList";
import MaterialAdd from "./components/routes/management/materialAdd";
import MaterialEdit from "./components/routes/management/materialEdit";
import MaterialPriceList from "./components/routes/management/materialPriceList";
import MaterialPriceAdd from "./components/routes/management/materialPriceAdd";
import MaterialPriceEdit from "./components/routes/management/materialPriceEdit";
import MaterialInventoryAdd from "./components/routes/management/materialInventoryAdd";
import MaterialInventoryLabel from "./components/routes/management/materialInventoryLabel";
import MaterialInventoryList from "./components/routes/management/materialInventoryList";
import MonthlySummaryByMaterialCostCreditReport from "./components/routes/reports/inactive/monthlySummaryByMaterialCostCredit";
import MonthlySummaryByMaterialReport from "./components/routes/reports/inactive/monthlySummaryByMaterialReport";
import MonthlyWeightSummaryReport from "./components/routes/reports/inactive/monthlyWeightSummaryReport";
import Sara313Report from "./components/routes/reports/inactive/sara313";
import ShipmentEdit from "./components/routes/shipments/shipmentEdit";
import ShipmentReport from "./components/routes/reports/shipmentReportByVendor";
import ShipmentList from "./components/routes/shipments/shipmentList";
import DeletedShipmentList from "./components/routes/shipments/deletedShipmentList";
import ShippedMaterials from "./components/routes/shipments/shippedMaterials";
import TrailerAdd from "./components/routes/trailers/trailerAdd";
import TrailerList from "./components/routes/trailers/trailerList";
import TransporterAdd from "./components/routes/management/transporterAdd";
import TransporterEdit from "./components/routes/management/transporterEdit";
import TransporterList from "./components/routes/management/transporterList";
import Vendors from "./components/routes/management/vendorList";
import VendorAdd from "./components/routes/management/vendorAdd";
import VendorEdit from "./components/routes/management/vendorEdit";
import VendorPricing from "./components/routes/management/vendorPricing";
import ShipmentReportByVendor from "./components/routes/reports/shipmentReportByVendor";
import ShipmentReportByMaterial from "./components/routes/reports/inactive/shipmentReportByMaterial";
import SummaryReport from "./components/routes/reports/summaryReport";
import ExpenseReport from "./components/routes/reports/expenseReport";
import MaterialReport from "./components/routes/reports/materialReport";
import ShipmentStatusReport from "./components/routes/reports/shipmentStatusReport";
import ClosingReport from "./components/routes/reports/closingReport";
import MaterialPricingReport from "./components/routes/reports/materialPricingReport";
import MonthlySummaryReport from "./components/routes/reports/monthlySummaryReport";
import ShipmentHistoryReport from "./components/routes/reports/shipmentHistoryReport";
import ReportRegistrationList from "./components/routes/management/reportRegistrationList";
import ReportRegistrationAdd from "./components/routes/management/reportRegistrationAdd";
import ReportRegistrationEdit from "./components/routes/management/reportRegistrationEdit";
import BatchList from "./components/routes/shipments/batchList";
import BatchAdd from "./components/routes/shipments/batchAdd";
import BatchEdit from "./components/routes/shipments/batchEdit";
import MonthlySummaryReportByVendor from "./components/routes/reports/monthlySummaryReportByVendor";
import WasteCharacterizationAdd from "./components/routes/management/wasteCharacterizationAdd";
import WasteCharacterizationUpdate from "./components/routes/management/wasteCharacterizationUpdate";
import WasteCharacterizationList from "./components/routes/management/wasteCharacterizationList";
import CustomerVendorDeltaReport from "./components/routes/reports/customerVendorDeltaReport";
import MaterialInventoryReport from "./components/routes/reports/materialInventoryReport";
import ShipmentManifestReportByVendor from "./components/routes/reports/shipmentManifestReportByVendor";
import ShipmentPacketList from "./components/routes/shipmentPacketAudit/shipmentPacketList";
import PowerBiReportViewer from "./components/powerBiReportViewer";


const router = createBrowserRouter([
    {
        path: '/',
        element: <Navigate to="/home" replace />,
		errorElement: <Error />
    },
	{
        path: '/home',
        element: <Home />,
		errorElement: <Error />
    },
	{
		path: '/appsettings',
		element: <AppSettingList />,
		errorElement: <Error />
	},
    {
        path: '/container',
        element: <ContainerList />,
		errorElement: <Error />
    },
    {
        path: '/container/add',
        element: <ContainerAdd />,
		errorElement: <Error />
    },
    {
        path: '/container/:id',
        element: <ContainerEdit />,
		errorElement: <Error />
    },
    {
        path: '/customer',
        element: <CustomerList />,
		errorElement: <Error />
    },
	{
        path: '/customer/add',
        element: <CustomerAdd />,
		errorElement: <Error />
    },
    {
        path: '/customer/:id',
        element: <CustomerEdit />,
		errorElement: <Error />
    },
    {
        path: '/customer/closing',
        element: <CustomerClosing />,
		errorElement: <Error />
    },
	{
        path: '/employee',
        element: <EmployeeList />,
		errorElement: <Error />
    },
	{
        path: '/employee/add',
        element: <EmployeeAdd />,
		errorElement: <Error />
    },
	{
        path: '/employee/:id',
        element: <EmployeeEdit />,
		errorElement: <Error />
    },
	{
        path: '/vendor',
        element: <Vendors />,
		errorElement: <Error />
    },
	{
        path: '/vendor/:id',
        element: <VendorEdit />,
		errorElement: <Error />
    },
	{
        path: '/vendor/:id/pricing',
        element: <VendorPricing />,
		errorElement: <Error />
    },
	{
        path: '/vendor/add',
        element: <VendorAdd />,
		errorElement: <Error />
    },
    {
        path: '/transporter',
        element: <TransporterList />,
		errorElement: <Error />
    },
	{
        path: '/transporter/:id',
        element: <TransporterEdit />,
		errorElement: <Error />
    },
	{
        path: '/transporter/add',
        element: <TransporterAdd />,
		errorElement: <Error />
    },
    {
        path: '/material',
        element: <MaterialList />,
		errorElement: <Error />
    },
    {
        path: '/material/add',
        element: <MaterialAdd />,
		errorElement: <Error />
    },
    {
        path: '/material/:id',
        element: <MaterialEdit />,
		errorElement: <Error />
    },
    {
        path: '/materialprice',
        element: <MaterialPriceList />,
		errorElement: <Error />
    },
	{
        path: '/materialprice/add',
        element: <MaterialPriceAdd />,
		errorElement: <Error />
    },
	{
        path: '/materialprice/:id',
        element: <MaterialPriceEdit />,
		errorElement: <Error />
    },
    {
        path: '/document',
        element: <DocumentList />,
		errorElement: <Error />
    },
    {
        path: '/document/add',
        element: <DocumentAdd />,
		errorElement: <Error />
    },
	{
        path: '/document/:id',
        element: <DocumentView />,
		errorElement: <Error />
    },
	{
        path: '/expense',
        element: <ExpenseList />,
		errorElement: <Error />
    },
	{
        path: '/expense/add',
        element: <ExpenseAdd />,
		errorElement: <Error />
    },
	{
        path: '/expense/:id',
        element: <ExpenseEdit />,
		errorElement: <Error />
    },
	{
        path: '/shipment',
        element: <ShipmentList />,
		errorElement: <Error />
    },
	{
        path: '/shipment/:id',
        element: <ShipmentEdit />,
		errorElement: <Error />
    },
	{
        path: '/shipment/deleted',
        element: <DeletedShipmentList />,
		errorElement: <Error />
    },
	{
		path: '/shipmentpacket',
		element: <ShipmentPacketList />,
		errorElement: <Error />
	},
	{
        path: '/batch',
        element: <BatchList />,
		errorElement: <Error />
    },
	{
        path: '/batch/add',
        element: <BatchAdd />,
		errorElement: <Error />
    },
	{
        path: '/batch/:id',
        element: <BatchEdit />,
		errorElement: <Error />
    },
	{
        path: '/shippedmaterials',
        element: <ShippedMaterials />,
		errorElement: <Error />
    },
	{
        path: '/report/registration',
        element: <ReportRegistrationList />,
		errorElement: <Error />
    },
	{
        path: '/report/registration/register',
        element: <ReportRegistrationAdd />,
		errorElement: <Error />
    },
	{
        path: '/report/registration/:id',
        element: <ReportRegistrationEdit />,
		errorElement: <Error />
    },
	{
        path: '/summaryreport',
        element: <SummaryReport />,
		errorElement: <Error />
    },
	{
        path: '/materialreport',
        element: <MaterialReport />,
		errorElement: <Error />
    },
	{
        path: '/expensereport',
        element: <ExpenseReport />,
		errorElement: <Error />
    },
	{
        path: '/shipmentstatusreport',
        element: <ShipmentStatusReport />,
		errorElement: <Error />
    },
    {
        path: '/costcreditreport',
        element: <CostCreditReport />,
		errorElement: <Error />
    },
	{
        path: '/closingreport',
        element: <ClosingReport />,
		errorElement: <Error />
    },
    {
        path: '/shipmentreportbymaterial',
        element: <ShipmentReportByMaterial />,
		errorElement: <Error />
    },
    {
        path: '/shipmentreportbyvendor',
        element: <ShipmentReportByVendor />,
		errorElement: <Error />
    },
	{
        path: '/shipmentmanifestreportbyvendor',
        element: <ShipmentManifestReportByVendor />,
		errorElement: <Error />
    },
    {
        path: '/loadweightsreport',
        element: <LoadWeightsReport />,
		errorElement: <Error />
    },
    {
        path: '/monthlyweightsummaryreport',
        element: <MonthlyWeightSummaryReport />,
		errorElement: <Error />
    },
    {
        path: '/monthlysummarybymaterialreport',
        element: <MonthlySummaryByMaterialReport />,
		errorElement: <Error />
    },
    {
        path: '/monthlysummarybymaterialcostcreditreport',
        element: <MonthlySummaryByMaterialCostCreditReport />,
		errorElement: <Error />
    },
    {
        path: '/sara313report',
        element: <Sara313Report />,
		errorElement: <Error />
    },
	{
        path: '/materialpricingreport',
        element: <MaterialPricingReport />,
		errorElement: <Error />
    },
	{
        path: '/materialinventoryreport',
        element: <MaterialInventoryReport />,
		errorElement: <Error />
    },
	{
        path: '/monthlysummaryreport',
        element: <MonthlySummaryReport />,
		errorElement: <Error />
    },
	{
        path: '/monthlysummaryreportbyvendor',
        element: <MonthlySummaryReportByVendor />,
		errorElement: <Error />
    },
	{
        path: '/shipmenthistoryreport',
        element: <ShipmentHistoryReport />,
		errorElement: <Error />
    },
	{
        path: '/customervendordeltareport',
        element: <CustomerVendorDeltaReport />,
		errorElement: <Error />
    },
	{
		path: '/report/:reportId/:workspaceId?',
		element: <PowerBiReportViewer />,
		errorElement: <Error />
	},
	{
        path: '/tils',
        element: <LoadList />,
		errorElement: <Error />
    },
	{
        path: '/tils/add',
        element: <LoadAdd />,
		errorElement: <Error />
    },
	{
        path: '/tils/deleted',
        element: <DeletedLoadList />,
		errorElement: <Error />
    },
	{
        path: '/tils/:id',
        element: <LoadEdit/>,
		errorElement: <Error />
    },
	{
		path: '/materialinventory',
		element: <MaterialInventoryList />,
		errorElement: <Error />
	},
	{
		path: '/materialinventory/add',
		element: <MaterialInventoryAdd />,
		errorElement: <Error />
	},
	{
		path: '/materialinventory/:id',
		element: <MaterialInventoryLabel />,
		errorElement: <Error />
	},
	{
        path: '/trailer',
        element: <TrailerList />,
		errorElement: <Error />
    },
	{
        path: '/trailer/add',
        element: <TrailerAdd />,
		errorElement: <Error />
    },
	{
        path: '/wastecharacterization',
        element: <WasteCharacterizationList />,
		errorElement: <Error />
    },
	{
        path: '/wastecharacterization/add',
        element: <WasteCharacterizationAdd />,
		errorElement: <Error />
    },
	{
        path: '/wastecharacterization/:id',
        element: <WasteCharacterizationUpdate />,
		errorElement: <Error />
    },
	{
        path: '/error',
        element: <Error />
    },
    {
        path: '/*',
        element: <Error />
    },
])

const Router = () => {
    return (
        <RouterProvider router={router} />
    );
}

export default Router;